'use client';
import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

const mobileNavItems = [
  { label: 'Home', href: '/', icon: 'HomeIcon' as const },
  { label: 'Community', href: '/community-feed', icon: 'UsersIcon' as const },
  { label: 'Pets', href: '/pet-profile', icon: 'HeartIcon' as const },
  { label: 'Shop', href: '/marketplace', icon: 'ShoppingBagIcon' as const },
  { label: 'Account', href: '/sign-up-login-screen', icon: 'UserCircleIcon' as const },
];

export default function AppMobileNav() {
  const pathname = usePathname();

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-md border-t border-border">
      <div className="flex items-center justify-around px-2 py-2 safe-area-pb">
        {mobileNavItems.map((item) => {
          const isActive = pathname === item.href || (item.href !== '/' && pathname.startsWith(item.href));
          return (
            <Link
              key={`mob-nav-${item.label}`}
              href={item.href}
              className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-colors no-underline min-w-0 ${
                isActive ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
              }`}
              aria-label={item.label}
            >
              <Icon
                name={item.icon}
                size={22}
                variant={isActive ? 'solid' : 'outline'}
                className={isActive ? 'text-primary' : 'text-muted-foreground'}
              />
              <span className={`text-[10px] font-bold leading-none ${isActive ? 'text-primary' : 'text-muted-foreground'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}